import { styled } from "styled-components";

export const DropText = styled.div`
  font-size: 24px;
  font-weight: 400;
  margin-left: 5px;
`;
